import { Box, Stack, Typography } from '@mui/material'
import React from 'react'
import LocationOnIcon from '@mui/icons-material/LocationOn';
import EmailIcon from '@mui/icons-material/Email';
import PhoneIcon from '@mui/icons-material/Phone';
import logo from "../assets/Frame 633222.png"
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import InstagramIcon from '@mui/icons-material/Instagram';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import FacebookIcon from '@mui/icons-material/Facebook';
function Footer() {
    return (
        <>
            <Stack sx={{ backgroundColor: '#15513c', py: 4 }} alignItems={"center"} justifyContent={"center"}>
                <Stack alignItems={"center"} justifyContent={"center"} sx={{ my: 2 }}>
                <img
                        src={logo}
                        alt="Logo"
                        style={{
                            width: 'auto', 
                            height: '80px', 
                            maxWidth: '120px', 
                            objectFit: 'contain', 
                            marginBottom: '10px',
                        }}
                    />
                </Stack>
                <Stack alignItems={"center"} justifyContent={"center"} direction={"row"} sx={{ color: "#fff" }} gap={2}>
                    <Typography variant='body1' sx={{ textAlign: "center", display: 'flex', alignItems: 'center' }}>
                        +963 988 594 320
                        <PhoneIcon />
                    </Typography>

                    <Typography variant='body1' sx={{ textAlign: "center", display: 'flex', alignItems: 'center' }}>
                        <a class="social-media-link" href='mailTo:Info.nabni.sy@gmail.com'>
                        Info.nabni.sy@gmail.com</a>
                        <EmailIcon />

                    </Typography>
                    <Typography variant='body1' sx={{ textAlign: "center", display: 'flex', alignItems: 'center' }}>
                        دمشق, سوريا
                        <LocationOnIcon />
                    </Typography>
                </Stack>
                <Stack alignItems={"center"} justifyContent={"center"} direction={"row"} sx={{ my: 2 }} gap={2}>
                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: "center", backgroundColor: "#fff", borderRadius: "100%", width: "35px", height: "35px" }}>
                        <a class="social-media-icon" href='https://api.whatsapp.com/send?phone=31687915225'><WhatsAppIcon /></a>
                    </Box>
                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: "center", backgroundColor: "#fff", borderRadius: "100%", width: "35px", height: "35px" }}>
                        <a class="social-media-icon" href='#'> <LinkedInIcon /></a>
                    </Box>
                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: "center", backgroundColor: "#fff", borderRadius: "100%", width: "35px", height: "35px" }}>
                        <a class="social-media-icon" href='https://www.instagram.com/nabni.syria/'><InstagramIcon /></a>
                    </Box>
                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: "center", backgroundColor: "#fff", borderRadius: "100%", width: "35px", height: "35px" }}>
                        <a class="social-media-icon" href='https://www.facebook.com/nabni.syria'><FacebookIcon /></a>
                    </Box>
                </Stack>
                <Typography variant='body2' sx={{ color: "#fff", textAlign: "center", width: "100%", my: 2 }}>جميع الحقوق محفوظة © 2025</Typography>
            </Stack>
        </>
    )
}

export default Footer